import { GENERIC_ANALYTICS_EVENTS } from 'Utilities/analytics/analyticsGenericEvents';

export const PROFILE_HUB = 'vehicle_hub';
export const PROFILE_CATEGORY = 'profile';

export const SP_PROFILE_HUB = Object.freeze({
  ESTIMATED_PRICE_HOVERED: (name: string, message: string) => GENERIC_ANALYTICS_EVENTS.HOVER_EVENT({
    category: PROFILE_CATEGORY,
    message,
    name,
  }),
  LOAD: (label?: string) => GENERIC_ANALYTICS_EVENTS.SECTION_LOAD_EVENT({
    category: PROFILE_CATEGORY,
    label,
    name: PROFILE_HUB,
  }),
  PAAS_GATE_CTA_CLICK: (buttonLabel: string, url: string) => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    button_label: buttonLabel,
    category: PROFILE_CATEGORY,
    name: 'paas_gate_cta',
    url,
  }),
  PAAS_GATE_LOADED: () => GENERIC_ANALYTICS_EVENTS.SECTION_LOAD_EVENT({
    category: PROFILE_CATEGORY,
    name: 'paas_gate',
  }),
  PAAS_GATE_PHONE_CLICK: (url: string) => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: PROFILE_CATEGORY,
    name: 'paas_gate_phone',
    url,
  }),
  SECTIONS: {
    BASIC: (label: string) => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
      category: PROFILE_CATEGORY,
      label,
      name: 'personal_information_section',
    }),
    HISTORY: (label: string) => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
      category: PROFILE_CATEGORY,
      label,
      name: 'service_history_section',
    }),
    PHOTOS: (label: string) => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
      category: PROFILE_CATEGORY,
      label,
      name: 'photos_section',
    }),
    VEHICLE: (label: string) => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
      category: PROFILE_CATEGORY,
      label,
      name: 'vehicle_information_section',
    }),
  },
});

export type SPSectionsKey = keyof typeof SP_PROFILE_HUB.SECTIONS;
